import type { ReactNode } from "react";

import { Check } from "lucide-react";
import { twMerge } from "tailwind-merge";

type UploadTargetCardProps = {
  controls: string;
  count: number;
  id: string;
  illustration: ReactNode;
  isSelected: boolean;
  onSelect: () => void;
  subtitle: string;
  title: string;
};

export function UploadTargetCard({
  controls,
  count,
  id,
  illustration,
  isSelected,
  onSelect,
  subtitle,
  title,
}: UploadTargetCardProps) {
  return (
    <button
      aria-controls={controls}
      aria-selected={isSelected}
      className={twMerge(
        "relative flex cursor-pointer flex-col gap-lg rounded-2xl border-[1.5px] border-border-secondary bg-bg-primary p-md pb-[14px] text-left transition-[border-color,box-shadow] hover:border-border-primary",
        isSelected &&
          "border-border-brand-solid ring-4 ring-border-brand-solid/10 hover:border-border-brand-solid",
      )}
      id={id}
      onClick={onSelect}
      role="tab"
      type="button"
    >
      <span
        className={twMerge(
          "absolute right-[14px] top-[14px] grid size-[22px] place-items-center rounded-full border-[1.5px] border-border-primary bg-bg-primary text-white sm:right-[18px] sm:top-[18px]",
          isSelected && "border-border-brand-solid bg-bg-brand-solid",
        )}
      >
        <Check className={isSelected ? "size-3.5" : "invisible size-3.5"} />
      </span>
      <span className="grid h-[88px] place-items-center overflow-hidden rounded-lg border border-border-secondary bg-bg-secondary sm:h-[112px]">
        {illustration}
      </span>
      <span className="flex flex-col px-sm">
        <span
          className={twMerge(
            "flex items-center gap-md text-md font-semibold text-text-primary",
            isSelected && "text-text-brand-primary",
          )}
        >
          {title}
          {count > 0 && (
            <span className="inline-grid h-[22px] min-w-[22px] place-items-center rounded-full bg-bg-tertiary px-[7px] text-xs font-semibold text-text-primary">
              {count}
            </span>
          )}
        </span>
        <span className="text-sm text-text-tertiary">{subtitle}</span>
      </span>
    </button>
  );
}
